<template>
  <div class="apply_electronic">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div">
          <div class="security_main_body_div_H1">旅游信息聚合</div>
          <div class="security_main_body_div_text">
            轻松收集各大网站的优惠信息，比较航班、酒店和旅游数据，分析客户搜索和关注内容，预测下一个旅游热点和趋势
          </div>
          <div class="security_main_body_div_butts">
            <div
              class="security_main_body_div_butt div_buttA"
              @click="loginshow"
            >
              免费试用
            </div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">
              产品价格
            </div>
          </div>
          <div class="apply_electronic_dzsw_d4">
            <div>
              <img src="http://apiupss.ppfly.top/images/banner_icon7.svg" alt="" />
              <div>真实家庭住宅</div>
            </div>
            <div>
              <img
                style="width: 60px"
                src="http://apiupss.ppfly.top/images/banner_icon10.png"
                alt=""
              />
              <div>小于1s响应时间</div>
            </div>
            <div>
              <img
                style="width: 60px"
                src="http://apiupss.ppfly.top/images/banner_icon6.png"
                alt=""
              />
              <div>HTTP(S)/Socks5协议</div>
            </div>
            <div>
              <img
                style="width: 60px"
                src="http://apiupss.ppfly.top/images/banner_icon11.svg"
                alt=""
              />
              <div>企业定制服务</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  优化SEO策略
                </div>
                <div class="security_main_body_divB_div_left_text">
                  深入分析网站流量和关键词，提高网站的可见性和SEO优化效果，抢占市场先机
                </div>
              </div>
              <div>
                <div class="applyele_list_img">
                  <div>
                    <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                  </div>
                  <div>
                    <div>优化搜索引擎结果</div>
                    <div class="applyele_list_img_text">
                      优化页面、标题、描述和链接，提高网站在搜索引擎中的排名，吸引更多流量
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                  </div>
                  <div>
                    <div>监控SERP数据</div>
                    <div class="applyele_list_img_text">
                      监测页面排名、流量变化及竞争对手位置等关键指标数据，及时调整SEO优化策略
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                  </div>
                  <div>
                    <div>反向链接</div>
                    <div class="applyele_list_img_text">
                      发现潜在的合作伙伴和引流渠道，增加高质量的反向链接，提高网站可信度和曝光度
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="security_main_body_divB_div_reft">
              <img src="http://apiupss.ppfly.top/images/introduce_r_8.svg" alt="" />
            </div>
          </div>
        </div>

        <apply_electronic_mainket />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_mainket from "@/components/apply_electronic_mainket/apply_electronic_mainket.vue";
export default {
  // apply-market
  name: "apply_travel",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_mainket,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay() {
      this.$router
        .push({
          path: "/pay",
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
      this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {},
  mounted() {
    this.totop();
  },
};
</script>
<style lang="scss" scoped>
.security_main_body {
  background-color: #f5f2f23a;
}
.security_main_body_div {
  background: url(http://apiupss.ppfly.top/images/buy-banner.bb39d3b.png);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 50px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1 {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
  max-width: 865px;
  margin: 31px auto 0;
}
.apply_electronic_dzsw_d4 {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.apply_electronic_dzsw_d4 img {
  margin-bottom: 30px;
}
.security_main_body_div_butts {
  display: flex;
  justify-content: center;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB {
  margin-top: 200px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 7px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
